import httpClient from './httpClient';

export const SEARCH_SETTING_ENDPOINT = '/backoffice/search_synonyms';

export const getSearchSynonymsAPI = async (params) => httpClient.get(`${SEARCH_SETTING_ENDPOINT}`, { params });
export const createSearchSynonymAPI = async (keywords) => httpClient.post(`${SEARCH_SETTING_ENDPOINT}`, { keywords });
export const deleteSearchSynonymAPI = (id) => httpClient.delete(`${SEARCH_SETTING_ENDPOINT}/${id}`);
